import { useMemo } from 'react';
import { useQuery as useReactQuery } from 'react-query';
import useClient from '@pkg/client/useClient';

const DefaultOptions = Object.freeze({
  retry: 4, // retry 4 times total
  retryDelay: (attempt) => attempt * 500, // linearly increase delay between attempts (in ms)
});

/**
 * @param {String} path
 * @param {Function} fetcher
 * @param {Object} [options]
 * @returns {Object}
 */
export default function useQuery(path, fetcher, options = {}) {
  const client = useClient();

  const { dataKey, dataDefault, dataHandler, ...InputOptions } = options;
  const result = useReactQuery(path, fetcher.bind(client), {
    ...DefaultOptions,
    ...InputOptions,
  });

  if (dataKey) {
    result[dataKey] = useMemo(() => {
      if (dataHandler instanceof Function) return dataHandler(result);
      return result.data?.data ?? dataDefault ?? null;
    }, [result.data]);
  }

  return result;
}
